export default __webpack_public_path__ + "static/media/larrow.fbeaeb75.svg";